import React, { } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';

/**
 *
 */
function StepInfo({ step, loading }) {
  /**
   *
   * @return {JSX.Element}
   */

  return (
    <div className="shopify-step-info-wrapper">
      {loading
        ? (
          <div className="shopify-step-info-loading__wrapper">
            {[1, 2, 3, 4]?.map((item) => (
              <div key={item} className="shopify-step-info-loading-line">
                <div className="loadingBlock shopify-step-info-loading-dot" />
                <div className="loadingBlock shopify-step-info-loading-text" />
              </div>
            ))}
          </div>
        )
        : (
          <div style={{ marginTop: '35px' }} className="shopify-step-border">
            <div className="shopify-step-info-status-wrapper">
              <div className={`dot  ${ step === 1 ? 'dot-blue' : 'dot-green'} `} />
              <div className="shopify-step-info-status-heading-active">&nbsp;Inventory Locations</div>
            </div>
            <div className="shopify-step-info-status-wrapper">
              <div className={`dot dot-grey ${ step === 2 ? 'dot-blue' : step > 2 && 'dot-green' }`} />
              <div className="shopify-step-info-status-heading-active">&nbsp;Initial Import</div>
            </div>
            <div className="shopify-step-info-status-wrapper">
              <div className={`dot dot-grey ${ step === 3 ? 'dot-blue' : step > 2 && 'dot-green' }`} />
              <div className="shopify-step-info-status-heading-active">&nbsp;Sync Setup</div>
            </div>
            <div className="shopify-step-info-status-wrapper">
              <div className={`dot dot-grey ${ step === 4 ? 'dot-blue' : step > 3 && 'dot-green' }`} />
              <div className="shopify-step-info-status-heading-active">&nbsp;Review & Save</div>
            </div>
          </div>
        )}
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({

});
StepInfo.propTypes = {
  step: PropTypes.any,
  loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StepInfo));
